export default {
  LIST(state, data) {
    state.list = data
  },
  UPDATE(state, value) {
    state.lang = { ...value }
  },
  FRESH(state) {
    state.lang = {}
  },
}
